import { render, staticRenderFns } from "./AgentBrand.vue?vue&type=template&id=37589ad9&scoped=true"
import script from "./AgentBrand.vue?vue&type=script&lang=js"
export * from "./AgentBrand.vue?vue&type=script&lang=js"
import style0 from "./AgentBrand.vue?vue&type=style&index=0&id=37589ad9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37589ad9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37589ad9')) {
      api.createRecord('37589ad9', component.options)
    } else {
      api.reload('37589ad9', component.options)
    }
    module.hot.accept("./AgentBrand.vue?vue&type=template&id=37589ad9&scoped=true", function () {
      api.rerender('37589ad9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/brandname/AgentBrand.vue"
export default component.exports